import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo } from 'react';
import { Element } from 'react-scroll';
import { Field } from 'redux-form';
import { propArrayShape, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import { getFormValue } from '../../../../../../helpers/form';
import { validateRegionOther } from '../../../../../../validate/solution';
import SolutionError from '../Error';
const RegionsCheckboxes = (props) => {
    const { formFields, name, nameOther, regions } = props;
    const { error, type } = useMemo(() => {
        if (_.get(formFields, `fields.${name}_list.touched`)) {
            const rawError = _.get(formFields, `syncErrors.${name}_list`);
            if (rawError) {
                return {
                    error: rawError,
                    type: 'region',
                };
            }
        }
        if (_.get(formFields, `fields.${nameOther}.touched`)) {
            const rawError = _.get(formFields, `syncErrors.${nameOther}`);
            if (rawError) {
                return {
                    error: rawError,
                    type: 'other',
                };
            }
        }
        return {
            error: null,
            type: null,
        };
    }, [formFields, name, nameOther]);
    const selectValues = getFormValue(formFields, name) || [];
    return (_jsxs(Element, Object.assign({ name: `${name}_view` }, { children: [_jsx("ul", Object.assign({ className: 'form-solution-select' }, { children: regions.map((region, index) => {
                    const id = `${name}#${region.value}`;
                    return (_jsxs("li", { children: [_jsx(Field, { className: 'mdc-checkbox__native-control', component: 'input', id: id, name: `${name}[${index}]`, type: 'checkbox', value: region.value }), ' ', _jsx("label", Object.assign({ htmlFor: id }, { children: region.label })), index === regions.length - 1 && (_jsx(Field, { className: `input-form-text is-after-select ${type === 'other' && 'is-warning'}`, component: 'input', name: nameOther, placeholder: '地方エリアの場合は県名を記入して下さい', props: {
                                    disabled: !selectValues[regions.length - 1],
                                }, type: 'text', validate: validateRegionOther }))] }, id));
                }) })), _jsx(SolutionError, { error: error })] })));
};
RegionsCheckboxes.propTypes = {
    formFields: propShape().isRequired,
    name: propStr().isRequired,
    nameOther: propStr().isRequired,
    regions: propArrayShape().isRequired,
};
export default RegionsCheckboxes;
